import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { BulkClearwaterTransactionsPanelComponent } from './lib/bulk-clearwater-transactions-panel.component'
import { BulkClearwaterTransactionsKey } from './panel-key'

export const BulkClearwaterTransactionsPanelConfig: PanelConfig = {
  key: BulkClearwaterTransactionsKey,
  title: 'Bulk Clearwater Transactions',
  description:
    'Perform various actions on Clearwater transactions in bulk. Finding transactions across accounts, editing, and creating',
  category: PanelCategory.BULK_TOOLS,
  panelComponent: BulkClearwaterTransactionsPanelComponent,
  accessPermission: 'accessBulkClearwaterTransactions',
}
